const _cookiesName: string = 'toggler-state'
const setCookieToggler = (cookiesValue: string) => {
  const _cookie = useCookie(_cookiesName, {
    path: "/",
    maxAge: 60 * 60 * 24 * 30 * 12,
  });
  if (_cookie.value === cookiesValue) {
    return
  }

  _cookie.value = String(cookiesValue);
};
const getValueFromTogglerCookie = (): string => {
  return useCookie(_cookiesName).value || "";
};

export {
  setCookieToggler,
  getValueFromTogglerCookie,
}
